import React from "react";
import { Dialog, DialogNavigation } from "../../../../components/modal/Dialog";

export const InactiveParentProductDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={"This product is currently inactive"}
        description={
          "All product items are hidden. Set to active to toggle the visibility of each product item."
        }
      />
    </Dialog>
  );
};
